import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";
import {getPhoneRuleObj} from "@/plugins/vee-validate";

export default class InventoryBulkEditModel extends BaseModel {
  uuid = null;
  tax_status_uuid = null;
  tax_rate = null;
  receive_date = null;
  quantity = null;
  item_location_uuid = null;
  collection_info_enabled = null;
  collection_info_address_1 = null;
  collection_info_address_2 = null;
  collection_info_state = null;
  collection_info_city = null;
  collection_info_municipality = null;
  collection_info_zip_code = null;
  collection_info_phone = null;
  collection_info_first_name = null;
  collection_info_last_name = null;
  collection_info_email = null;
  collection_info_notes = null;
  account_managers_uuid = null;
  rep_user_uuid = null;
  expert_user_uuid = null;
  cataloguing_lifecycle = null;
  photography_lifecycle = null;
  low = null;
  high = null;
  start_price = null;
  reserve = null;
  buy_now_price = null;
  longitude = null;
  latitude = null;
  dynamic_fields = {};

  empty_tax_status_uuid = false;
  empty_tax_rate = false;
  empty_receive_date = false;
  empty_quantity = false;
  empty_item_location_uuid = false;
  empty_collection_info_enabled = false;
  empty_collection_info_address_1 = false;
  empty_collection_info_address_2 = false;
  empty_collection_info_state = false;
  empty_collection_info_city = false;
  empty_collection_info_municipality = false;
  empty_collection_info_zip_code = false;
  empty_collection_info_phone = false;
  empty_collection_info_first_name = false;
  empty_collection_info_last_name = false;
  empty_collection_info_email = false;
  empty_collection_info_notes = false;
  empty_account_managers_uuid = false;
  empty_rep_user_uuid = false;
  empty_expert_user_uuid = false;
  empty_cataloguing_lifecycle = false;
  empty_photography_lifecycle = false;
  empty_low = false;
  empty_high = false;
  empty_start_price = false;
  empty_reserve = false;
  empty_buy_now_price = false;
  empty_longitude = false;
  empty_latitude = false;
  empty_dynamic_fields = {};


  customMessages = {
    "start_price": {
      max_value: function () {
        return i18n.t("The 'Start Price' must be lower than the 'Reserve' price.")
      }
    }
  }

  rules = {
    low: 'min_value:1',
    high: 'min_value:1',
    start_price: 'min_value:0',
    reserve: 'min_value:1',
    buy_now_price: 'min_value:1',
    tax_rate: 'max_value:100|min_value:0',
    quantity: 'min_value:1|max_value:1000000',

    collection_info_email: 'email|max:73',
    collection_info_notes: 'max:150',
    collection_info_phone: getPhoneRuleObj(),
    longitude: 'min_value:-180|max_value:180',
    latitude: 'min_value:-85|max_value:85',
  };

  attributeHints = {
    tax_status_uuid: i18n.t("Vendor tax status will be assigned if the 'Clear' checkbox is chosen for the field."),
    tax_rate: i18n.t("Vendor tax rate will be assigned if the 'Clear' checkbox is chosen for the field."),
  };

  attributeLabels = {
    quantity: i18n.t('Quantity'),
    rep_user_uuid: i18n.t('Representative User'),
    expert_user_uuid: i18n.t('Expert User'),
    receive_date: i18n.t('Receive Date'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    start_price: i18n.t('Start Price'),
    reserve: i18n.t('Reserve'),
    buy_now_price: i18n.t('Buy Now'),
    item_location_uuid: i18n.t('Item Location'),
    tax_status_uuid: i18n.t('Tax Status'),
    tax_rate: i18n.t('Tax Rate'),

    collection_info_enabled: i18n.t('Collection Information'),
    collection_info_address_1: i18n.t('Address 1'),
    collection_info_address_2: i18n.t('Address 2'),
    collection_info_city: i18n.t('City'),
    collection_info_municipality: i18n.t('Municipality'),
    collection_info_state: i18n.t('State/County'),
    collection_info_zip_code: i18n.t('Zip/Postcode'),
    collection_info_phone: i18n.t('Phone'),
    collection_info_first_name: i18n.t('Contact First Name'),
    collection_info_last_name: i18n.t('Contact Last Name'),
    collection_info_email: i18n.t('Email'),
    collection_info_notes: i18n.t('Collection Notes'),
    longitude: i18n.t('Longitude'),
    latitude: i18n.t('Latitude'),
    account_managers_uuid: i18n.t('Account Manager'),
    cataloguing_lifecycle: i18n.t('Cataloguing Lifecycle'),
    photography_lifecycle: i18n.t('Photography Lifecycle'),
  };

  attributeTitleHint = {
    tax_status_uuid: i18n.t('Bulk Edit Input Hint'),
    tax_rate: i18n.t('Bulk Edit Input Hint'),
    receive_date: i18n.t('Bulk Edit Input Hint'),
    quantity: i18n.t('Bulk Edit Input Hint'),
    item_location_uuid: i18n.t('Bulk Edit Input Hint'),
    collection_info_enabled: i18n.t('Bulk Edit Input Hint'),
    collection_info_address_1: i18n.t('Bulk Edit Input Hint'),
    collection_info_address_2: i18n.t('Bulk Edit Input Hint'),
    collection_info_state: i18n.t('Bulk Edit Input Hint'),
    collection_info_city: i18n.t('Bulk Edit Input Hint'),
    collection_info_municipality: i18n.t('Bulk Edit Input Hint'),
    collection_info_zip_code: i18n.t('Bulk Edit Input Hint'),
    collection_info_phone: i18n.t('Bulk Edit Input Hint'),
    collection_info_first_name: i18n.t('Bulk Edit Input Hint'),
    collection_info_last_name: i18n.t('Bulk Edit Input Hint'),
    collection_info_email: i18n.t('Bulk Edit Input Hint'),
    collection_info_notes: i18n.t('Bulk Edit Input Hint'),
    account_managers_uuid: i18n.t('Bulk Edit Input Hint'),
    rep_user_uuid: i18n.t('Bulk Edit Input Hint'),
    expert_user_uuid: i18n.t('Bulk Edit Input Hint'),
    low: i18n.t('Bulk Edit Input Hint'),
    high: i18n.t('Bulk Edit Input Hint'),
    start_price: i18n.t('Bulk Edit Input Hint'),
    reserve: i18n.t('Bulk Edit Input Hint'),
    buy_now_price: i18n.t('Bulk Edit Input Hint'),
    longitude: i18n.t('Bulk Edit Input Hint'),
    latitude: i18n.t('Bulk Edit Input Hint'),
    cataloguing_lifecycle: i18n.t('Bulk Edit Input Hint'),
    photography_lifecycle: i18n.t('Bulk Edit Input Hint'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
